//
// Capability.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var Capability = {
    UNKNOWN:0,
    ACCESS_ESRI_PREMIUM_SERVICES:1,
    ACCESS_MOBILE_BI:2,
    ACCESS_RECENTS:3,
    ACCESS_SETTINGS:4,
    ACCESS_VISUAL_ANALYTICS:5,
    ACCESS_VISUAL_ANALYTICS_VIEWER:6,
    ADD_SHARE:7,
    ALLOW_WEB_CONTENT:8,
    ADD_COMMENTS:9,
    BROWSE_HDFS:10,
    BUILD_CUSTOM_GRAPH:11,
    COMMENTS:12,
    CREATE_ACTIVITY:13,
    CREATE_COLLECTIONS:14,
    CREATE_EXPLORATION:15,
    CREATE_REPORT:16,
    EMAIL:17,
    EXPORT_DATA:18,
    EXPORT_DETAIL_DATA:19,
    EXPORT_IMAGE:20,
    EXPORT_PDF:21,
    EXPORT_EXCEL:22,
    EXPORT_REPORT:23,
    IMPORT_AND_LOAD_DATA:24,
    INTERPRET_REPORT_VIEWER_NATURAL_LANGUAGE:25,
    INSIGHT_REPORT:26,
    GET_STATE_REPORT_VIEWER_NATURAL_LANGUAGE:27,
    UPDATE_STATE_REPORT_VIEWER_NATURAL_LANGUAGE:28,
    LIMIT_OFFLINE_ACCESS:29,
    MANAGE_CUSTOM_LISTS:30,
    MANAGE_ENVIRONMENT:31,
    MANAGE_FAVORITES:32,
    MANAGE_LASR_SERVER:33,
    MANAGE_MOBILE_DEVICES:34,
    MONITOR_LASR:35,
    PERSONALIZATION:36,
    PREPARE_DATA:37,
    PURGE_MOBILE_REPORT_DATA:38,
    REFRESH_DATA:39,
    RENDER_REPORT_IMAGES:40,
    REQUIRE_APPLICATION_PASSCODE:41,
    SUBSCRIBE_TO_REPORT_ALERTS:42,
    TEXT_TEMPLATES:43,
    VAA_TABLE_AUTHORIZATION:44,
    VIEW_COMMENTS:45,
    VIEW_FAVORITES:46,
    VIEW_REPORT:47,
    VIEW_SHARES:48
};
export default Capability;
